import { useCreation } from 'ahooks'

import { TemplateEntity } from '@eastcoal/api/contract/interface'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { ContractTemplateSelectProps } from './interface'

const resolveOptions = (value?: TemplateEntity[]) =>
  value?.map(item => ({ label: item.name, value: item?.id }))

const getOptionValue = (value: TemplateEntity) => `${value.id}`

export const ContractTemplateSelect = ({
  value,
  onChange,
  mode,
  disabled,
  bizType,
  memberId,
  ...rest
}: ContractTemplateSelectProps) => {
  const requestParams = useCreation(
    () => ({
      bizType,
      memberId
    }),
    [bizType, memberId]
  )
  return (
    <RemoteSelect
      {...rest}
      allowClear
      api={() => [] as any}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={mode}
      readyRequest={!!memberId}
      refreshDeps={[memberId, bizType]}
      requestParams={requestParams}
      resolveOptions={resolveOptions}
      value={value}
      onChange={onChange}
    />
  )
}
